import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
//import { Phone } from "@mui/icons-material";

const defaultToolbarStyles = {
    iconButton: {
    },
};


class ProductAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ProductId: null,
            Name: null,
            Description: null,
            ListPrice: null,
            Expenses: null,
            Unit: null,
            ExternalLink: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            ProductId: null,
            Name: null,
            Description: null,
            ListPrice: null,
            Expenses: null,
            Unit: null,
            ExternalLink: null,
            Modifier: null,
            StartTime: null,
            EndTime: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            ProductId: 1,
            Name: this.state.Name,
            Description: this.state.Description,
            ListPrice: this.state.ListPrice,
            Expenses: this.state.Expenses,
            Unit: this.state.Unit,
            ExternalLink: this.state.ExternalLink,
            Modifier: this.state.Modifier,
            StartTime: this.state.StartTime,
            EndTime: this.state.EndTime
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Product.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Product.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Product.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Description}
                            onChange={this.handleChange('Description')}
                        />
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Product.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.ListPrice}
                            onChange={this.handleChange('ListPrice')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Product.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Expenses}
                            onChange={this.handleChange('Expenses')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Product.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Unit}
                            onChange={this.handleChange('Unit')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Product.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.ExternalLink}
                            onChange={this.handleChange('ExternalLink')}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ProductAdd" })(ProductAdd);
